import React from "react";

const Contact = ({ data }) => {
  const {
    profile = {},
    office = {},
    constituency = {},
    
  } = data || {};

  const {
    fullName = "the Honourable",
  } = profile;

  const {
    constituency: officeConstituency = constituency.constituency,
  } = office;

  const {
    town = "",
    state = "",
  } = constituency;

  

  const email =  profile.email ? profile.email : null;
  const phone = profile.phone ? profile.phone : null;

  const phoneHref = profile.phone
    ? `tel:${profile.phone.replace(/\s/g, "")}`
    : null;

  const location = [town, state]
    .filter(Boolean)
    .join(", ");

  return (
    <section
      className="contact-section"
      id="contact"
      aria-labelledby="contact-title"
    >
      <div className="container contact-grid">

        {/* LEFT CONTENT */}
        <div className="contact-content">

          <p className="section-label light">
            <span />
            CONNECT WITH THE OFFICE
          </p>

          <h2 id="contact-title">
            Let's stay{" "}
            <em>connected.</em>
          </h2>

          <p>
            Reach the office of{" "}
            {fullName} for enquiries,
            constituency concerns and official
            communication.
          </p>

          <div className="contact-info">

            <div>
              <span>CONSTITUENCY</span>

              <strong>
                {officeConstituency || "—"}
              </strong>
            </div>

            <div>
              <span>LOCATION</span>

              <strong>
                {location || "—"}
              </strong>
            </div>

          </div>

        </div>

        {/* RIGHT CONTACT CARD */}
        <div className="contact-card">

          <span className="contact-card-label">
            OFFICIAL OFFICE
          </span>

          <h3>
            Get in touch with the constituency
            office.
          </h3>

          {email && (
            <a href={`mailto:${email}`}>
              {email}
            </a>
          )}

          {phone && phoneHref && (
            <a href={phoneHref}>
              {phone}
            </a>
          )}

          {email && (
            <a
              className="contact-card-button"
              href={`mailto:${email}`}
            >
              Send a Message

              <span aria-hidden="true">
                →
              </span>
            </a>
          )}

        </div>

      </div>
    </section>
  );
};

export default Contact;